import React from "react";
import { connect } from "react-redux";
import { Checkbox, Select } from "../Input";
import language from "../../language";
import icons from "../../constants/icons";
import { fetchBusinessCategories } from "../../queries/business/businessCategoriesQuery";
import { Button } from "../Button";
import { getStorage, setStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { saveProfileUnits } from "../../actions/ProfileUnits";
import { fetchMerchantID } from "../../queries/merchantID/merchantIDQuery";
import activeCountriesQuery from "../../queries/country/activeCountriesQuery";
import api from "../../utils/api";

class BusinessCategory extends React.Component {
  state = {
    isLoading: true,
    data: [],
    error: {},
    countries: [],
    isTermsAccepted: false,
  };

  componentDidMount = async () => {
    this.getBusinessCategories(true);
    this.getActiveCountries(true);
  };

  getBusinessCategories = async (isLoadingCategories) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCategories });

      const data = await fetchBusinessCategories(defaultLanguage, {
        listType: "dropdown",
      });

      this.setDefaultBusinessCategory(data);

      this.setState({
        isLoading: false,
        data,
      });
    } catch (error) {
      this.setState({ isLoadingCategories: false });
    }
  };

  setDefaultBusinessCategory = async (categories) => {
    const user = await getStorage();

    if (user.businessCategory && user.businessCategoryId)
      categories.forEach((el) => {
        if (el.id === user.businessCategoryId) {
          this.setState({
            businessCategory: {
              label: el.name,
              id: el.id,
            },
          });
        }
      });
  };

  getActiveCountries = async (isLoadingCountries) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCountries });

      const countries = await activeCountriesQuery(defaultLanguage, {
        listType: "dropdown",
      });

      this.setState({
        countries,
        isLoadingCountries: false,
      });
    } catch (error) {
      this.setState({ isLoadingCountries: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e,
      error,
    });
  }

  validateForm() {
    let { error, businessCategory, country } = this.state;

    if (!businessCategory) {
      error.businessCategory =
        language[this.props.defaultLanguage].business_category_required;
    }

    if (!country) {
      error.country = language[this.props.defaultLanguage].country_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    const { error, businessCategory, country } = this.state;

    await this.validateForm();

    if (Object.keys(error).length === 0) {
      let user = await getStorage();
      const { accessToken } = user;

      this.setState({
        isSubmitting: true,
      });

      const options = {
        url: `${api("profile")}/organisation/business/category`,
        method: "POST",
        data: {
          businessCategoryId: businessCategory.id,
          countryId: country.value,
        },
        headers: {
          authorization: "Bearer " + accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.onSuccess(data.data);
        })
        .catch((error) => {
          this.setState({ isSubmitting: false });

          toastMessage(
            "error",
            language[this.props.defaultLanguage].unable_create_business_category
          );
        });
    }
  };

  onSuccess = async (data) => {
    try {
      let user = await getStorage();
      const { businessCategory, country } = this.state;
      const { profileUnits, organisationBusinessCategory } = data;

      //fetch merchant ID
      const merchantID = await fetchMerchantID(this.props.defaultLanguage);

      //save merchant ID
      await setStorage({ merchantID: merchantID.identifier }, "merchantID");

      //save information and update user profile
      user["organizationId"] = organisationBusinessCategory.id;
      user["businessCategory"] = businessCategory.label;
      user["businessCategoryId"] = businessCategory.value;
      user["countryId"] = country.value;
      user["countryName"] = country.label;

      //save profile units information in redux storage
      this.props.dispatch(saveProfileUnits(profileUnits));

      this.setState({ isSubmitting: false });

      //update session storage for profile
      await setStorage(user);

      //redirect to the next step
      window.location.href = "/merchant/kyc/onboarding/stepTwo";
    } catch (error) {
      this.setState({ isSubmitting: false });

      toastMessage("error", error);
    }
  };

  handleCheckTerms() {
    this.setState({
      isTermsAccepted: !this.state.isTermsAccepted,
    });
  }
  render() {
    return (
      <div className="gap-4">
        <center
          className="mb-5"
          style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}
        >
          <div className="icon-header">
            <span className={`${process.env.REACT_APP_ICONS_TYPE}`}>
              {icons.business_profile}
            </span>
          </div>
          <h2>Please select a business category to start KYC application </h2>
          <small className="text-primary text-bold">Step 1 / 2</small>
        </center>
        <div className="card">
          <div className="card-body">
            <Select
              options={this.state.data}
              label={language[this.props.defaultLanguage].business_category}
              placeholder={language[this.props.defaultLanguage].select}
              leftIcon={icons.business_profile}
              error={this.state.error.businessCategory}
              onChange={(e) => this.onChangeInput("businessCategory", e)}
              value={this.state.businessCategory}
              isLoading={this.state.isLoading}
              required
            />
            <Select
              options={this.state.countries}
              leftIcon={icons.country}
              label={language[this.props.defaultLanguage].country}
              placeholder={language[this.props.defaultLanguage].select}
              value={this.state.country}
              onChange={(e) => this.onChangeInput("country", e)}
              error={this.state.error.country}
              isLoading={this.state.isLoadingCountries}
              required
            />
            <div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  checked={this.state.isTermsAccepted}
                  onChange={this.handleCheckTerms.bind(this)}
                />
                <span>
                  By continuing, you agree to our{" "}
                  <b>
                    <a
                      href="https://dataintegrated.co.ke/terms"
                      target="_blank"
                      className="text-primary"
                    >
                      Terms & Conditions
                    </a>
                  </b>{" "}
                  and acknowledge our{" "}
                  <b>
                    <a
                      href="https://dataintegrated.co.ke/privacy-policy"
                      target="_blank"
                      className="text-primary"
                    >
                      Privacy Policy
                    </a>
                  </b>{" "}
                  .
                </span>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              text={language[this.props.defaultLanguage].proceed}
              onPress={this.onSubmit.bind(this)}
              isSubmitting={this.state.isSubmitting}
              disabled={!this.state.isTermsAccepted}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BusinessCategory);
